import Carousel from '@components/carousel/dynamicCarousel';
import getMetroSpecifics$ from 'api/getMetroSpecificArticles';
import { readCookie } from 'modules/cookieManager';
import { filter, fromEvent, map, switchMap } from 'rxjs';
import { camelCaseObjectKeys } from 'utils/camelCase';

const onDocumentContentLoaded$ = fromEvent(document, 'DOMContentLoaded');
const metroSpecificContainerSelector = "[data-metro-specific-subjects-container]";
const metroSpecificSectionSelector = "[data-section-name='metroSpecificSubjects']"

/* Object is defining selectors for different elements within a specific section
of the webpage to set up the Carousel. */
const settings = {
  itemListQuerySelector: `${metroSpecificSectionSelector} [data-blog-article-cards-list]`,
  previousQuerySelector: `${metroSpecificSectionSelector} [data-left-arrow]`,
  nextQuerySelector: `${metroSpecificSectionSelector} [data-right-arrow]`,
};

/**
 * Function to render metro area content based on location and initializes a carousel component.
 * @param metroAreaContentByLocation - The `metroAreaContentByLocation` parameter is a string that
 * contains the content specific to a metro area location. This content will be rendered in a specific
 * section of the webpage based on the location provided. If this parameter has a value, the existing
 * content in that section will be replaced with the new one.
 */
const renderMetroSpecificSection = function (metroAreaContentByLocation){
    const metroSpecificMainContainer = document.querySelector(metroSpecificContainerSelector);

    if (metroSpecificMainContainer){

        // By default we are loading the Metro Area Section, if "data" has value we are retriving
        // the content by location, we remove the previous content to load the new one
        if (metroAreaContentByLocation){
          metroSpecificMainContainer.innerHTML = '';
        }
        
        const fragment = document.createRange().createContextualFragment(metroAreaContentByLocation);
        metroSpecificMainContainer.appendChild(fragment);

        const carousel = new Carousel();
        carousel.setSettings(settings);
        carousel.create();
    }
}

/* Observable to get the a new metro specific article section based on the personal user session */
onDocumentContentLoaded$
.pipe(
  map(() => document.querySelector("[data-component='metro-area-section-command-data']")),
  filter(metroAreaSectionCommand => Boolean(metroAreaSectionCommand)),
  map((metroAreaSectionCommand) => camelCaseObjectKeys(
    JSON.parse(metroAreaSectionCommand.innerHTML))),
  switchMap((metroAreaSectionCommand) => {

    const personalCookie = readCookie('Personal', true);
    const urlParams = new URLSearchParams(personalCookie);

    metroAreaSectionCommand.marketId = urlParams.get('market') || 0;
    metroAreaSectionCommand.marketStateAbbreviation =urlParams.get('state') || '';
    
    return getMetroSpecifics$(metroAreaSectionCommand);
  })
)
.subscribe(renderMetroSpecificSection);